/*
 * Copyright (C) 2021 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import { CSP_NONCE, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { AppComponent } from 'app/components/app/app.component';
import { HeaderComponent } from 'app/components/header/header.component';
import { GridComponent } from 'app/components/grid/grid.component';
import { NotificationInputsComponent } from 'app/components/notification-inputs/notification-inputs.component';

import { NotificationsUrlDataProviderService } from 'app/services/url-data-provider.service';

import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import {
  EntryFieldModule,
  ENVIRONMENT,
  EnvironmentService,
  IconModule,
  OGFormsModule,
  OGGridModule,
  OGMiscModule
} from '@opengamma/ui';
import { MAT_TOOLTIP_DEFAULT_OPTIONS, MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { NotificationSubmissionService } from 'app/services/notification-submission.service';
import { SafeHtmlPipe } from 'app/safe-html.pipe';
import { environment } from 'environments/environment';

@NgModule({
  bootstrap: [AppComponent],
  declarations: [
    AppComponent,
    HeaderComponent,
    GridComponent,
    NotificationInputsComponent,
    SafeHtmlPipe
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FlexLayoutModule,
    MatTooltipModule,
    MatButtonToggleModule,
    OGGridModule,
    OGMiscModule,
    OGFormsModule,
    EntryFieldModule,
    IconModule
  ],
  providers: [
    NotificationsUrlDataProviderService,
    NotificationSubmissionService,
    {
      provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
      useValue: {
        showDelay: 0,
        hideDelay: 0,
        touchendHideDelay: 1000,
        position: 'above'
      }
    },
    { provide: CSP_NONCE, useValue: 'notif-ui' },
    {
      provide: ENVIRONMENT,
      useValue: environment
    },
    EnvironmentService,
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule {}
